export default __webpack_public_path__ + "static/media/location-icon.4c263f49.svg";